/*********** simple_header_login.js *************** */
// imported into main.js
// creates a simple stuff banner at the top of the page
// includes links to facebook, twitter, and myStuff login

import '../css/simple_header_login.scss';

  // (function () {
const body = document.querySelector('body'),
    login = document.querySelector('.login'),
    header = document.createElement('div');
  header.classList.add('stuff_simpleheader');
  //body.prepend(header);
body.insertBefore(header, login);

  // let header = document.querySelector('.stuff_simpleheader'),
    let stuffheader_body = document.createElement('div'),
      stuffheader_left = document.createElement('div'),
      stuffLink = document.createElement('a'),
      stuffheader_right = document.createElement('div'),
      stuffSocial = document.createElement('div'),
      stuffheader_color_bar = document.createElement('div'),
      fbLink = document.createElement('a'),
      twitterLink = document.createElement('a'),
      stuffLogin = document.createElement('div'),
      shareURL = encodeURIComponent(document.querySelector("[property='og:url']").content),
      fbDescription = encodeURIComponent(document.querySelector("[property='og:description']").content),
      twitterDescription = encodeURIComponent(document.querySelector("[name='twitter:description']").content),
      breakWidth = 840,
      debounceScroll,
      prevScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  stuffheader_body.classList.add('stuffheader_body');
  stuffheader_left.classList.add('stuffheader_left');
  stuffLink.classList.add('stufflogo');
  stuffLink.href = "https://stuff.co.nz";
  stuffheader_right.classList.add('stuffheader_right');

  stuffheader_left.appendChild(stuffLink);

  stuffSocial.classList.add('shareBlock');

  fbLink.classList.add('shareBtn');
  fbLink.classList.add('share_facebook');
  twitterLink.classList.add('shareBtn');
  twitterLink.classList.add('share_twitter');
  stuffSocial.appendChild(fbLink);
  stuffSocial.appendChild(twitterLink);

stuffLogin.classList.add('stuffLogin');
  // remove when login scripts running //
  //stuffLogin.innerText = 'Login';
//
  stuffheader_right.appendChild(stuffSocial);
  stuffheader_right.appendChild(stuffLogin);

  stuffheader_body.appendChild(stuffheader_left);
  stuffheader_body.appendChild(stuffheader_right);

  stuffheader_color_bar.classList.add('stuff_color_bar');

  header.appendChild(stuffheader_body);
  header.appendChild(stuffheader_color_bar);

  // debounce function by David Walsh (https://davidwalsh.name/javascript-debounce-function)
    // used to prevent functions being triggered too often on screen resize
    function debounce(func, wait, immediate) {
      var timeout;
      return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

  //calculates viewport size
  function getWindowDim () {
    let width = Math.min(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      ),
      height = Math.min (
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.documentElement.clientHeight,
        window.innerHeight
      );
    return { width: width, height: height};
  }

  function difference (a, b){
    return Math.abs(Math.abs(a) - Math.abs(b));
  }

  debounceScroll = debounce(function() {
    let windowWidth = getWindowDim().width,
        currScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if(windowWidth < breakWidth && difference(currScrollTop, prevScrollTop) > 25) {
      let scrollDirection = currScrollTop > prevScrollTop ? 'down' : 'up';
      if(scrollDirection === 'down') {
        header.style.top = -(header.offsetHeight - 3) + 'px';
      } else {
        header.style.top = '0px';
      }
    } else {
      header.style.top = '0px';
    }

    prevScrollTop = currScrollTop;
  }, 100);

  fbLink.addEventListener('click', function(e) {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = ( windowWidth - 600) / 2,
        fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + shareURL;
    if(windowWidth > breakWidth) {
      window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(fbURL);
    }
  });

  twitterLink.addEventListener('click', function(e) {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = (windowWidth - 600) / 2,
        twitURL = "https://twitter.com/intent/tweet?url=" + shareURL + "&text=" + twitterDescription + "&via=NZSTUFF";

    if(windowWidth > breakWidth) {
      window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(twitURL);
    }
  });

   // move first element after header to below the fixed header height
   login.nextElementSibling.classList.add('addheaderspace');

  window.addEventListener('scroll', debounceScroll);

//})();